import { ReactNode, JSX } from 'react';

type ConditionalRenderHOCProps = {
  shouldHide: boolean;
  children: ReactNode;
};

const ConditionalRenderHOC = ({
  shouldHide,
  children
}: ConditionalRenderHOCProps): JSX.Element =>
  shouldHide ? <div className="hidden">{children}</div> : <>{children}</>;

export default ConditionalRenderHOC;
